<template>
  <template v-if="!isYourDesignProductType && !isDigitalProductProductType">
    <div class="product__option product__shipping">
      <h2 class="bordered-bottom">
        <template v-if="productStore.product">
          {{ themeData('productShippingTitle') }}
          {{
            shouldLoadProductDescriptionAndShippingByVariantType &&
            selectedVariantStyleOptionValue
              ? `for ${selectedVariantStyleOptionValue}`
              : ''
          }}
        </template>
        <sib-skeleton-loading v-else width="10em"></sib-skeleton-loading>
      </h2>
      <template
        v-if="
          requestLocation.countryCode?.toUpperCase() == US_COUNTRY_CODE &&
          !hasExpressShippingChinaProductTag
        "
        ><p>
          <strong
            >The estimated shipping time applies to the continental US,
            excluding AK, HI, US Military, US Islands.</strong
          >
        </p></template
      >
      <ProductShippingCollapsible
        :isCollapsible="productStore.isProductUINewVersion"
      >
        <!-- start logic apply for camp mth7138 -->
        <template v-if="isExpressShippingChina">
          <template
            v-if="
              requestLocation.countryCode?.toUpperCase() == US_COUNTRY_CODE &&
              hasShipFromUsProductTag &&
              !typeSelectedHiddenShippingFromUS
            "
          >
            <h2>Produced in and Shipped from the US</h2>
            <ProductShippingSummary
              :product-shipping="
                productStore.shippingFromUS || fixedShippingFromUS
              "
            ></ProductShippingSummary>
          </template>
          <template
            v-if="productStore.selectedShippedOption != US_COUNTRY_CODE"
          >
            <p class="product__shipping-from-title mb-md">
              Produced in and
              <span style="color: red">Express Shipped</span> from Overseas
            </p>
            <ProductShippingSummary
              :product-shipping="expressShipping"
            ></ProductShippingSummary>
          </template>

          <p class="product__shipping-from-title">
            Produced in and Shipped from Overseas
          </p>
          <ProductShippingSummary
            :product-shipping="
              productStore.shippingFromChina || fixedShippingFromChina
            "
          ></ProductShippingSummary>
          <!-- end logic apply for camp mth7138 -->
        </template>
        <template v-else>
          <template
            v-if="
              isExpressShipping &&
              (!productStore.selectedShippedOption ||
                productStore.selectedShippedOption == US_COUNTRY_CODE)
            "
          >
            <p class="product__shipping-from-title mb-md">
              Produced in and
              <span style="color: red">Express Shipped</span> from the US
            </p>
            <ProductShippingSummary
              :product-shipping="expressShipping"
            ></ProductShippingSummary>
          </template>
          <template v-if="hasOptionShippedFrom">
            <p class="product__shipping-from-title mt-0">
              Produced in and
              <span
                v-if="
                  isExpressShipping &&
                  (!productStore.selectedShippedOption ||
                    productStore.selectedShippedOption == US_COUNTRY_CODE)
                "
                >Standard</span
              >
              Shipped from the US
            </p>
            <ProductShippingSummary
              :product-shipping="
                productStore.shippingFromUS || fixedShippingFromUS
              "
            ></ProductShippingSummary>
            <p class="product__shipping-from-title">
              Produced in and Shipped from Overseas
            </p>
            <ProductShippingSummary
              :product-shipping="
                productStore.shippingFromChina || fixedShippingFromChina
              "
            ></ProductShippingSummary>
            <!-- <div class="product__shipping-from mb-sm">
              <a href="/pages/asian-factories-2025-holiday-shipping-delay-notice" style="color:#15609b;text-decoration: underline;">Estimated Shipping from Overseas Includes Asian Factories' 2025 Holiday Delays</a>
            </div> -->
          </template>
          <template v-else>
            <p
              v-if="isExpressShipping"
              class="product__shipping-from-title mt-0"
            >
              Produced in and Standard Shipped from the US
            </p>
            <ProductShippingSummary></ProductShippingSummary>
          </template>
        </template>
      </ProductShippingCollapsible>

      <template v-if="isProductShippingLoaded">
        <template v-if="!hasOptionShippedFrom">
          <div class="product__shipping-from product__made-to-order mb-sm">
            <sib-image
              :src="themeData('iconProduction')"
              alt="production icon"
              :width="22"
              :height="12"
            ></sib-image>
            <span>
              The product is <span class="text--bold"> made to order </span>
            </span>
          </div>
          <div class="product__shipping-from mb-sm">
            <sib-image
              :src="
                isShippedFromUS
                  ? themeData('iconDomestic')
                  : themeData('iconPlane')
              "
              alt="ship by icon"
              :width="22"
              :height="12"
            ></sib-image>
            <span>
              Produced In and Shipped from
              <span class="text--bold">
                {{ isShippedFromUS ? 'the US' : 'Overseas' }}
              </span>
            </span>
          </div>
          <!-- <div v-if="!isShippedFromUS" class="product__shipping-from mb-sm">
            <a href="/pages/asian-factories-2025-holiday-shipping-delay-notice" style="color:#15609b;text-decoration: underline;">Estimated Shipping Includes Asian Factories' 2025 Holiday Delays</a>
          </div> -->
        </template>

        <!-- <div class="cut-off-christmas" v-if="!productHasXmasTag">
          Delivery may be affected by the year-end peak season.
          <sib-link
            to="/pages/delivery-cut-off-date-for-2024-christmas"
            title="DELIVERY CUT-OFF DATE FOR 2024 CHRISTMAS"
            >Details here.</sib-link
          >
        </div> -->

        <!-- Popup for mobile -->
        <LightBoxPopup
          group="product-shipping"
          contentId="product-shipping-popup-content"
          class="hidden-md-up mt-md"
        >
          <template #trigger>
            <span
              class="link hidden-md-up"
              @click="trackingProductShippingDetailsOpened(false)"
              >Shipping & Return policies <InfoIcon
            /></span>
          </template>
          <div v-html="shippingPolicy"></div>
        </LightBoxPopup>

        <!-- Collapsible for desktop -->
        <ProductCollapsible
          detailsHeader="Shipping & Return policies"
          class="hidden-md-down shipping-return-policies-desktop"
          @toggle="trackingProductShippingDetailsOpened"
        >
          <div v-html="shippingPolicy"></div>
        </ProductCollapsible>
      </template>
    </div>
  </template>
</template>
<script lang="ts" setup>
import useProductStore from '@/store/product'
import useSettingsStore from '@/store/setting'
import { computed } from '@vue/reactivity'
import { onMounted, watch, ref } from 'vue'
import {
  EVENT_TRACKING_SHOW_PRODUCT_SHIPPING,
  TIME_MARK_CSR_LOAD_PAGE,
  TIME_MARK_SHOW_PRODUCT_SHIPPING,
  CSR_LOAD_TYPE,
  MEASURE_NAME_PRODUCT_SHIPPING_LOADED,
  EVENT_TRACKING_PRODUCT_SHIPPING_DETAILS_OPENED,
  MIXPANEL_DESTINATION,
  destinationIntegrations,
  PRODUCT_TYPE_YOUR_DESIGN,
  PRODUCT_TYPE_DIGITAL_PRODUCT,
  OPTION_TYPE_SHIPPED_FROM,
  US_COUNTRY_CODE,
  PRODUCT_TAG_EXPRESS_SHIPPING_PREFIX,
  PRODUCT_TAG_EXPRESS_SHIPPING_CHINA,
  TYPE_OPTIONS,
  PRODUCT_HANDLE_CAMP_WIN,
  PRODUCT_TAG_SHIP_FROM_US,
} from '@/utils'
import {
  isProductHasTagStartWith,
  isProductHasTags,
  isProductHasType,
} from '@/utils/product'
import ProductCollapsible from './ProductCollapsible.vue'
import LightBoxPopup from '@/ui-kits/LightBoxPopup.vue'
import { useRoute } from 'vue-router'
import useRouteStore from '@/store/route'
import Analytics from '@/services/analytics'
import ProductShippingSummary from './ProductShippingSummary.vue'
import { useProductShipping } from './composables/useProductShipping'
import InfoIcon from '@/assets/images/icons/info-icon.svg'
import useRequestLocationStore from '@/store/requestLocation'
import LocationService from '@/services/location'
import ProductShippingCollapsible from './ProductShippingCollapsible.vue'
import { themeData } from '@/themes'

performance.mark(TIME_MARK_SHOW_PRODUCT_SHIPPING)

const route = useRoute()
const routeStore = useRouteStore()
const productStore = useProductStore()
const settingStore = useSettingsStore()

const {
  isShippedFromUS,
  isProductShippingLoaded,
  initiateProductShipping,
  isEnableShippedFromOption,
  fixedShippingFromChina,
  fixedShippingFromUS,
} = useProductShipping()

const requestLocation = useRequestLocationStore()

const productHasXmasTag = computed(() =>
  isProductHasTags(productStore.product, ['xmas', 'occasion-Christmas Day'])
)

const hasOptionShippedFrom = computed(() => {
  if (!isEnableShippedFromOption.value) return
  if (requestLocation.countryCode?.toUpperCase() != US_COUNTRY_CODE) return

  return productStore.selectedVariant?.selectedOptions?.find(
    (selectedOption) => selectedOption.name === OPTION_TYPE_SHIPPED_FROM
  )
})

const hasShipFromUsProductTag = computed(() =>
  isProductHasTags(productStore.product, [PRODUCT_TAG_SHIP_FROM_US])
)

const isExpressShipping = computed(() => {
  return (
    isProductHasTagStartWith(
      productStore.product,
      PRODUCT_TAG_EXPRESS_SHIPPING_PREFIX
    ) &&
    requestLocation.countryCode?.toLowerCase() == US_COUNTRY_CODE.toLowerCase()
  )
})

const isExpressShippingChina = computed(() => {
  return (
    isProductHasTagStartWith(
      productStore.product,
      PRODUCT_TAG_EXPRESS_SHIPPING_PREFIX
    ) &&
    hasExpressShippingChinaProductTag.value &&
    requestLocation.countryCode?.toLowerCase() == US_COUNTRY_CODE.toLowerCase()
  )
})

const hasExpressShippingChinaProductTag = computed(() => {
  return isProductHasTags(productStore.product, [
    PRODUCT_TAG_EXPRESS_SHIPPING_CHINA,
  ])
})

// logic show size for camp mth7138
const typeSelectedHiddenShippingFromUS = computed(() => {
  return (
    productStore.product?.handle == PRODUCT_HANDLE_CAMP_WIN &&
    (getSelectedOption(TYPE_OPTIONS) == 'Zip Hoodie' ||
      getSelectedOption(TYPE_OPTIONS) == 'Fleece Zip Hoodie' ||
      getSelectedOption(TYPE_OPTIONS) == 'Kid Hoodie')
  )
})

const expressShippingLocation = ref<any>(null)

const expressShipping = computed(() => {
  if (expressShippingLocation.value) {
    return expressShippingLocation.value
  }

  const { maximumShipping, minimumShipping, processing } =
    productStore.productExpressShippingTime

  return {
    maximum_shipping: maximumShipping,
    minimum_shipping: minimumShipping,
    processing,
    ship_from: US_COUNTRY_CODE,
  }
})

const esimateProcessingDay = computed(() => {
  let minimumProcessingDay = productStore.productShippingTime.processing - 1
  let maximumProcessingDay = productStore.productShippingTime.processing + 1
  if (minimumProcessingDay <= 0) {
    minimumProcessingDay = 1
    maximumProcessingDay = 3
  }
  return {
    minimumProcessingDay,
    maximumProcessingDay,
  }
})

const shippingPolicy = computed(() => {
  const { minimumProcessingDay, maximumProcessingDay } =
    esimateProcessingDay.value
  return `
      <div class="product__shipping-policy">
        <h3> Shiping </h3>
        <ul>
          <li>
            <p>
              <strong>Production time:
              </strong>
              All orders are processed within ${minimumProcessingDay} - ${maximumProcessingDay} business days.
            </p>
          </li>
          <li>
            <p>
              <strong>Shipping time:
              </strong>
              Typically it takes up to ${productStore.productShippingTime.minimumShipping} - ${productStore.productShippingTime.maximumShipping} business days to arrive at an address.
              This time is from the date that it is shipped out, not the day the order is placed.
            </p>
          </li>
          <li>
            <p>
              <strong>Tracking number:
              </strong>
              When available, we will send you the tracking number with the confirmation email so that you can track the package online.
            </p>
          </li>
        </ul>
        <div class="mt-sm">
          <h3> Exchange, return & refund </h3>
        </div>
        ${settingStore.shop?.returnAndRefundPolicy}
      </div>
        `
})

const shouldLoadProductDescriptionAndShippingByVariantType = computed(
  () => productStore.shouldLoadProductDescriptionAndShippingByVariantType
)

const selectedVariantStyleOptionValue = computed(
  () => productStore.selectedVariantStyleOptionValue
)

const isYourDesignProductType = computed(() => {
  return isProductHasType(productStore?.product, [PRODUCT_TYPE_YOUR_DESIGN])
})

const isDigitalProductProductType = computed(() => {
  return isProductHasType(productStore?.product, [PRODUCT_TYPE_DIGITAL_PRODUCT])
})

onMounted(() => {
  // if enable shipped from option, product shipping will be fetched on product mounted
  if (!isEnableShippedFromOption.value) {
    watch(
      () => productStore.product?.id,
      (newVal, oldVal) => {
        if (newVal !== oldVal && newVal) {
          initiateProductShipping()
        }
      },
      { immediate: true }
    )
  }
  trackingShowProductShipping()

  watch(
    () => productStore.productExpressShippingTime,
    () => {
      LocationService.onLocationReady((location) => {
        const temp = [
          'MI',
          'IN',
          'OH',
          'PA',
          'NY',
          'CT',
          'NJ',
          'DE',
          'MD',
          'VA',
          'NC',
          'SC',
          'GA',
          'KY',
          'WV',
          'WI',
          'IL',
          'MN',
          'IA',
          'TN',
        ]
        if (
          isExpressShipping.value &&
          location?.region_code &&
          temp.includes(location?.region_code)
        ) {
          // do nothing
        } else {
          const { maximumShipping, minimumShipping, processing } =
            productStore.productExpressShippingTime

          expressShippingLocation.value = {
            maximum_shipping: maximumShipping + 1,
            minimum_shipping: minimumShipping,
            processing,
            ship_from: US_COUNTRY_CODE,
          }
        }
      })
    },
    { immediate: true }
  )
})

function getSelectedOption(name: string = '') {
  if (!productStore.selectedVariant?.selectedOptions) return ''
  const selectedOption = productStore.selectedVariant.selectedOptions.find(
    (o) => o.name === name
  )
  if (!selectedOption) return ''
  return selectedOption.value
}

function trackingShowProductShipping() {
  if (!productStore.product?.handle) return
  const performanceTimeProductShippingLoaded =
    routeStore.loadType == CSR_LOAD_TYPE
      ? performance.measure(
          MEASURE_NAME_PRODUCT_SHIPPING_LOADED,
          TIME_MARK_CSR_LOAD_PAGE
        ).duration
      : performance.now()

  const selfTimeProductShippingLoaded = performance.measure(
    MEASURE_NAME_PRODUCT_SHIPPING_LOADED,
    TIME_MARK_SHOW_PRODUCT_SHIPPING
  ).duration

  Analytics.track(
    EVENT_TRACKING_SHOW_PRODUCT_SHIPPING,
    {
      performance_time: performanceTimeProductShippingLoaded,
      self_time: selfTimeProductShippingLoaded,
      handle: productStore.product.handle,
      load_type: routeStore.loadType,
    },
    destinationIntegrations([MIXPANEL_DESTINATION])
  )
}

function trackingProductShippingDetailsOpened(isCollapsed: boolean) {
  if (!productStore.product || isCollapsed) return
  Analytics.track(
    EVENT_TRACKING_PRODUCT_SHIPPING_DETAILS_OPENED,
    {
      handle: productStore.product.handle,
      tags: productStore.product.tags,
      path: route.path,
    },
    destinationIntegrations([MIXPANEL_DESTINATION])
  )
}
</script>

<style lang="scss">
.product__shipping {
  &-from {
    display: flex;
    align-items: center;
    font-size: 12px;
    gap: 0.75em;
  }

  .link {
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  &-policy {
    h3 {
      font-size: 16px;
    }

    @include media-md-up {
      h3 {
        font-size: 14px;
      }
    }
  }

  &-from-title {
    font-weight: 600;
  }

  .shipping-return-policies-desktop {
    margin-top: var(--space-medium);
    .collapsible__header {
      font-size: 16px;
      font-weight: 600;
      color: unset;
      background: unset;
      padding-left: 0;
    }
  }
}
.cut-off-christmas {
  font-size: 12px;
  color: var(--text-color-secondary);
}
</style>
